import popupCloseImage from '../img/popup-close.png'
import '../css/popup.css'


function Popup({setPopupOpened}) {


    return <div className="popup-area">
        <div className="popup-close-button-container" onClick={() => setPopupOpened(false)}>
            <img className="popup-close-button-image" src={popupCloseImage} alt='error'/> 
        </div>
        <div className="popup-text">Обнаружено стороннее соединение. Для корректной работы требуется отключить VPN.
        </div>
    </div>
};

export default Popup;